(function() {

	angular
		.module('ngmvac')
		.filter('minMaxPriceFilter', MinMaxPrice);

	function MinMaxPrice() {
		return function(arr, totalNoches) {
			var array = [];
			angular.forEach(arr, function(hotel) {
				angular.forEach(hotel.packageGrouped, function(group) {
					angular.forEach(group, function(pack, index) {
						if(index == 0){
							var pack_  = pack.price / totalNoches;
							// pack.price = pack.price / totalNoches;
							if( array.length > 0 ) {
								if( pack_ < array[0] ) {
									array[0] = pack_;
								}
								if( pack_ > array[1] ) {
									array[1] = pack_;
								}
							} else {
								array[0] = pack_;
								array[1] = pack_;
							}
						}
					})
				})
			});
			return array;
		}
	}

})();